import ApiService from "@/utils/api.service"
import {
  AUTH_LOGOUT,
  AUTH_REQUEST,
  AUTH_SUCCESS,
  CHECK_AUTH,
  TOKEN_REQUEST,
} from "../actions/auth"
import JwtService from "@/utils/jwt.service"

export default {
  state: {
    user: {},
    accessToken: JwtService.getToken() || "",
    refreshToken: JwtService.getRefreshToken() || "",
  },

  getters: {
    isAuthenticated: (state) => !!state.accessToken,
  },

  actions: {
    [TOKEN_REQUEST]: ({ commit }, credentials) => {
      return new Promise((resolve, reject) => {
        ApiService.post(`auth/sendToken`, credentials)
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            commit("auth/" + AUTH_LOGOUT, err, { root: true })
            reject(err)
          })
      })
    },
    [AUTH_REQUEST]: ({ commit }, credentials) => {
      return new Promise((resolve, reject) => {
        ApiService.post(`auth/loginToken`, credentials)
          .then((resp) => {
            JwtService.saveToken(resp.data.auth_token, resp.data.refresh_token)
            ApiService.setHeader()
            commit(AUTH_SUCCESS, resp.data)
            resolve(resp)
          })
          .catch((err) => {
            commit("auth/" + AUTH_LOGOUT, err, { root: true })
            reject(err)
          })
      })
    },
    [AUTH_LOGOUT]: ({ commit }) => {
      return new Promise((resolve) => {
        commit(AUTH_LOGOUT)
        resolve()
      })
    },
    [CHECK_AUTH]({ commit }) {
      if (JwtService.getRefreshToken()) {
        return new Promise((resolve, reject) => {
          ApiService.post("auth/token", {
            refresh_token: JwtService.getRefreshToken(),
          })
            .then((resp) => {
              JwtService.saveToken(
                resp.data.auth_token,
                resp.data.refresh_token
              )
              ApiService.setHeader()
              commit(AUTH_SUCCESS, resp.data)
              resolve(resp)
            })
            .catch((err) => {
              //commit(AUTH_LOGOUT)
              reject(err)
            })
        })
      } else {
        console.log("no token")
        //commit(AUTH_LOGOUT)
        Promise.reject("no_token")
      }
    },
  },

  mutations: {
    [AUTH_SUCCESS](state, data) {
      state.accessToken = data.auth_token
    },
    [AUTH_LOGOUT](state) {
      JwtService.destroyToken()
      ApiService.removeHeader()
      state.refreshToken = null
      state.accessToken = null
    },
  },
}
